export const NOT_APPLICABLE = 'not_applicable'
